import Icon from "@mui/material/Icon";
// import MDBadge from "../../../../components/MDBadge";
import {useEffect, useMemo, useState} from "react";
import CustomService from "../../../services/custome.service";
import GHIconButton from "../../../components/GHIconButton";

export function useProvincesTable(clickItem) {

  const [rows, setRows] = useState([]);

  const columns = [
    { Header: "Name", accessor: "name", width: "20%" },
    { Header: "Country", accessor: "country", width: "20%" },
    { Header: "Abbreviation", accessor: "abbreviation", width: "20%" },
    { Header: "Actions", accessor: "action", width: "7%" },
  ];

  useEffect(() => {
    CustomService.getAllProvinces()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); 

  return {
    columns,
    rows: rows
      ? rows.map((element) => ({
          id: element.id,
          name: element.name,
          country: element.country?.name || "",
          abbreviation: element.abbreviation,
          action: (
            <GHIconButton
              onClick={clickItem}
              id={element.id}
              title="Delete"
              icon="delete"
              size="small"
              color="error"
            />
          ),
        }))
      : [],
  };
}
